import ShowcaseContextInstance from 'src/sdk-components/ShowcaseContextInstance';
export const iShowcaseContext = async () => {
  return ShowcaseContextInstance.get();
};
export default iShowcaseContext;
